import { NgModule } from "@angular/core";
import { BrowserModule, Title } from "@angular/platform-browser";
// import { RouteReuseStrategy } from '@angular/router';

import { RouterModule, Routes } from "@angular/router";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";

import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
// import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { environment } from "../environments/environment";
import { IonicStorageModule } from "@ionic/storage";
import { DatePipe } from "@angular/common";
import * as firebase from "firebase/app";
import "firebase/firestore";
// import { YoutubePipe } from './youtube.pipe';
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialModule } from "./material.module";
import { MatTreeModule } from "@angular/material/tree";

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    // AngularFirestoreModule.enablePersistence().AngularFj,  // ? https://youtu.be/oFNsTQDSwUw?t=60
    // AngularFirestoreModule.enablePersistence(), // enable persistence allows app to run offline
    AngularFirestoreModule,
    AngularFireAuthModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    MatTreeModule,
    BrowserAnimationsModule,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    MatTreeModule,
    DatePipe,
    Title,
    // { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
